var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { API_URLS } from '../../constants/apiConstants';
import { GATEWAY_URL } from '../../utils/common/apiConfig';
import httpPost from '../../utils/http/httpPost';
/**
 * 로그아웃시 RefreshToken 만료 요청을 위한 API.
 */
var fetchAppLogout = function (requestParameter, requestConfig) {
    var refreshToken = requestParameter.refreshToken;
    // refreshToken 파라미터가 없는 경우 에러 발생
    if (!refreshToken) {
        throw new Error('fetchAppLogout: requestParameter is invalid');
    }
    var requestBodyParams = JSON.stringify({
        refreshToken: refreshToken,
    });
    var filledRequestConfig = __assign(__assign({}, requestConfig), { data: requestBodyParams });
    return httpPost("".concat(GATEWAY_URL).concat(API_URLS.APP_LOGOUT), filledRequestConfig)
        .then(function (response) {
        return response;
    })
        .catch(function (e) {
        throw e;
    });
};
export default fetchAppLogout;
